/* global axios */
import ApiClient from '../ApiClient';

class AssistantAgents extends ApiClient {
  constructor() {
    super('assistant/agents', { accountScoped: true });
  }

  get({ page = 1, searchKey, kind, assignedToMe } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        search_key: searchKey,
        kind,
        assigned_to_me: assignedToMe,
      },
    });
  }

  create(data = {}) {
    return axios.post(this.url, { agent: data });
  }

  update(id, data = {}) {
    return axios.patch(`${this.url}/${id}`, { agent: data });
  }

  playground({ agentId, messageContent, messageHistory }) {
    return axios.post(`${this.url}/${agentId}/playground`, {
      message_content: messageContent,
      message_history: messageHistory,
    });
  }

  templates() {
    return axios.get(`${this.url}/templates`);
  }

  generateFaq(agentId) {
    return axios.post(`${this.url}/${agentId}/generate_faq`);
  }
}

export default new AssistantAgents();
